import { useEffect } from 'react';
import { useActivePlayer } from '@/context/ActivePlayerContext';
import { getUser } from '@/library/UserSessionHelper';
import { useAppNavigation } from '@/hooks/useAppNavigation';
import { IModuleSettings } from '@/library/ModuleSettingsHelper';
import Iron from './Iron';
import Utility from './Utility';
import Wedge from './Wedge';
import LoftLie from './LoftLie';
import Putter from './Putter';
import TransferClub from './TransferClub';
import BallShoeGlove from './BallShoeGlove';
import PlayerInfo from './PlayerInfo';
import { ModuleName } from '@/constants';
import Metals from './Metals';
import Loading from './Loading';
import styles from './Player.module.scss';

function Player() {
  const { activeModule, isLoading, error } = useActivePlayer();
  const { goToTourBagPage } = useAppNavigation();

  useEffect(() => {
    // if the TourBag module is not enabled redirect to the landing page
    const fetchModuleSettings = async () => {
      const user = await getUser();
      const moduleSettings = user?.moduleSettings as IModuleSettings;
      // we don't have a different landing page so redirect to TourBag
      if (!moduleSettings?.tourBag) goToTourBagPage();
    };
    fetchModuleSettings();
  }, []);

  useEffect(() => {
    document.scrollingElement?.scrollTo({
      top: 0,
      behavior: 'auto',
    });
  }, [activeModule]);

  if (isLoading) return <Loading />;

  if (error) {
    return (
      <div className={styles.container}>
        <h2 className={styles.errorTitle}>{error.type === 'sync' ? 'Sync Required' : 'Player Data'}</h2>
        <p className={styles.errorMessage}>{error.message} Please check your connection and try again.</p>
        {error.type === 'sync' && <p className={styles.errorHint}>Please ensure you have an active internet connection to download the required data.</p>}
        {/* {error.type === 'generic' && <p className={styles.errorHint}>There was an error retrieving player data. Please try again.</p>} */}
      </div>
    );
  }

  // here states will handle the different tabs which we'll render - driver | iron | etc
  let content: React.ReactNode;
  switch (activeModule as ModuleName) {
    case 'Driver':
      content = <Metals headTypeDescription="Driver" />;
      break;
    case 'Fairway':
      content = <Metals headTypeDescription="Fairway" />;
      break;
    case 'Hybrid':
      content = <Metals headTypeDescription="Hybrid" />;
      break;
    case 'Iron':
      content = <Iron />;
      break;
    case 'Utility':
      content = <Utility />;
      break;
    case 'Wedge':
      content = <Wedge />;
      break;
    case 'Loft & Lie':
      content = <LoftLie />;
      break;
    case 'Putter':
      content = <Putter />;
      break;
    case 'Transfer Club':
      content = <TransferClub />;
      break;
    case 'Ball, Shoe, Glove':
      content = <BallShoeGlove />;
      break;
    case 'Player Info':
      content = <PlayerInfo />;
      break;
    default:
      content = null;
  }

  return <div key={activeModule}>{content}</div>;
}

export default Player;
